var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCarbonIntensityHighIcon = function SvgCarbonIntensityHighIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 95,
    viewBox: "0 0 68 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 95L52.3727 69L45.7454 43H13.2546L0 95H59Z",
    fill: "#AE0A30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M46.824 2.45866C41.5354 3.87574 37.8397 8.18532 37.1604 13.1747C36.3305 13.1299 35.4275 13.2384 34.5401 13.4761C29.7662 14.7553 26.7343 19.5547 27.6255 24.3712C27.377 24.4378 26.9709 24.4131 26.5805 24.5177C23.0666 25.4592 20.9369 29.0821 21.8716 32.5707C22.8064 36.0592 26.4622 38.1319 29.9761 37.1903C32.6205 36.4818 34.4403 34.2582 34.8558 31.7623C36.2827 32.0476 37.7672 32.0505 39.2757 31.6463C41.7957 30.971 43.7825 29.3704 44.9813 27.3132C47.5449 28.3623 50.5805 28.6172 53.4733 27.842C60.5189 25.9542 64.7735 18.6906 62.9088 11.7313C61.044 4.772 53.8696 0.570803 46.824 2.45866Z",
    fill: "#AE0A30"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCarbonIntensityHighIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "carbon_intensity_high_icon.c057a8b988a9b5a7b39dcd622574f5a4.svg";